module.exports = __webpack_public_path__ + "assets/5f7549834bbd029cbbd5fb3082e13942.mp4";